import { CheckCircleIcon } from '@heroicons/react/outline';
import clsx from 'clsx';
import { useState } from 'react';
import Loader from '../Loader';

let WhiteCheckIcon = (
  <CheckCircleIcon className="my-auto mr-2 inline-flex h-5 w-5 text-gray-200" aria-hidden="true" />
);

let Load = <Loader className="mr-2 h-4 w-4 text-white" />;

interface ActionButtonProps {
  text?: string;
  loading?: boolean;
  disabled?: boolean;
  color?: string;
  type?: string;
  onClick?: () => {};
  className?: string;
  children?: string;
}

function ActionButton({
  text = 'Zapisz',
  loading,
  disabled,
  color,
  onClick,
  className,
  children,
}: ActionButtonProps) {
  const [isClicked, setIsClicked] = useState(false);

  const handleClick = () => {
    setIsClicked(true);
    onClick && onClick();
    setTimeout(function () {
      setIsClicked(false);
    }, 2000);
  };
  let defaultStyle =
    ' w-full inline-flex justify-center rounded-md py-2 px-4 my-2 text-sm font-medium focus:ring-2 focus:ring-gray-200 ';
  let colored = ' bg-teal-500 ';
  let isBorder = ' border-2 border-teal-500 ';
  let outline = ' bg-white ';
  let textWhite = ' text-white ';
  let textDark = ' text-gray-700 ';
  if (!disabled) {
    defaultStyle += ' hover:text-white hover:bg-teal-500 ';
  }
  return (
    <button
      disabled={disabled}
      onClick={handleClick}
      type="submit"
      className={clsx(
        defaultStyle,
        color ? colored + textWhite : outline + textDark,
        disabled ? ' bg-gray-500 ' + textWhite : isBorder,
        ` ${className} `,
      )}
    >
      {!loading ? isClicked && WhiteCheckIcon : Load}
      {children || text}
    </button>
  );
}

export default ActionButton;
